export interface ComicDetail {
  slug: string;
  title: string;
  author: string;
  artist: string;
  genre: string[];
  status: string;
  description: string;
  cover: string;
  rating: number;
  views: string;
  followers: string;
  totalChapters: number;
  lastUpdate: string;
  tags: string[];
  chapters: ChapterItem[];
}

export interface ChapterItem {
  id: number;
  title: string;
  date: string;
  isFree: boolean;
}

export const comicDetails: Record<string, ComicDetail> = {
  "solo-leveling": {
    slug: "solo-leveling",
    title: "我独自升级",
    author: "Chugong",
    artist: "张成乐 (DUBU)",
    genre: ["热血动作", "奇幻冒险"],
    status: "已完结",
    description:
      "十年前，世界各地出现了连接异次元的「传送门」，而人群中亦出现了觉醒之人——「猎人」。猎人们利用其自身能力，在传送门中讨伐魔物获取报酬。主人公成振宇是最低等级的E级猎人，被戏称为「人类最弱兵器」。在一次D级地下城的探索中，他和队友遭遇了前所未有的危机——一个双重地下城。在生死关头，他接受了一个神秘的任务，获得了独一无二的「升级系统」，成为世界上唯一一个可以无限变强的猎人。从此，他的命运发生了翻天覆地的变化...",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20of%20a%20mysterious%20hunter%20with%20glowing%20blue%20eyes%20and%20dark%20armor%2C%20shadow%20figures%20behind%2C%20dark%20atmosphere%2C%20clean%20simple%20background%2C%20vertical%20poster%20style&width=400&height=560&seq=detail-cover-01&orientation=portrait",
    rating: 9.8,
    views: "2.8亿",
    followers: "156万",
    totalChapters: 179,
    lastUpdate: "2026-08-03",
    tags: ["系统流", "升级", "爽文", "暗黑", "逆袭", "战斗"],
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: 179 - i,
      title: `第${179 - i}话${i === 0 ? " 终章" : ""}`,
      date: `2026-${String(8 - Math.floor(i / 3)).padStart(2, "0")}-${String((i % 28) + 1).padStart(2, "0")}`,
      isFree: i > 3,
    })),
  },
  "duke-contract-fiancee": {
    slug: "duke-contract-fiancee",
    title: "公爵的契约未婚妻",
    author: "Milcha",
    artist: "鲸鱼",
    genre: ["恋爱漫画", "古风历史"],
    status: "连载中",
    description:
      "她重生成了小说里的配角——那个注定要被退婚的公爵未婚妻。为了改变命运，她主动向公爵提出契约婚姻。本以为只是一场各取所需的交易，却没想到公爵大人竟然认真了起来...「既然签了契约，你就是我的人了。」面对这个霸道又深情的男人，她的心开始动摇。然而，原著的剧情似乎也在悄然改变，等待她的是一个未知的未来。",
    cover:
      "https://readdy.ai/api/search-image?query=Beautiful%20Korean%20romance%20manhwa%20cover%20with%20elegant%20noblewoman%20in%20a%20stunning%20gown%2C%20soft%20romantic%20lighting%2C%20vintage%20European%20palace%20background%2C%20warm%20golden%20tones%2C%20vertical%20poster%20style&width=400&height=560&seq=detail-cover-02&orientation=portrait",
    rating: 9.6,
    views: "1.9亿",
    followers: "128万",
    totalChapters: 156,
    lastUpdate: "2026-08-04",
    tags: ["重生", "契约婚姻", "欧风", "霸道公爵", "女强", "浪漫"],
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: 156 - i,
      title: `第${156 - i}话`,
      date: `2026-${String(8 - Math.floor(i / 4)).padStart(2, "0")}-${String((i % 30) + 1).padStart(2, "0")}`,
      isFree: i > 2,
    })),
  },
  "sword-master-second-son": {
    slug: "sword-master-second-son",
    title: "剑术名家的二公子",
    author: "Yuwol",
    artist: "疾风",
    genre: ["奇幻冒险", "热血动作"],
    status: "连载中",
    description:
      "身为大陆最强剑术名家的次子，秦云从小活在天才兄长的阴影之下。所有人都认为他只是一个资质平平的废物。直到那天，他在家族的禁地中觉醒了传说中的「剑魂」，一股来自远古的力量涌入体内。从此，他踏上了一条逆天改命的道路，那些曾经嘲笑过他的人终将仰望他的背影。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%20featuring%20a%20handsome%20young%20swordsman%20with%20flowing%20hair%2C%20sword%20in%20hand%2C%20cherry%20blossom%20petals%2C%20ancient%20Korean%20aesthetic%2C%20warm%20spring%20colors%2C%20vertical%20poster&width=400&height=560&seq=detail-cover-03&orientation=portrait",
    rating: 9.5,
    views: "1.5亿",
    followers: "98万",
    totalChapters: 98,
    lastUpdate: "2026-08-04",
    tags: ["剑术", "废材逆袭", "东方玄幻", "热血", "成长"],
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: 98 - i,
      title: `第${98 - i}话`,
      date: `2026-${String(8 - Math.floor(i / 4)).padStart(2, "0")}-${String((i % 30) + 1).padStart(2, "0")}`,
      isFree: true,
    })),
  },
  "villainess-redemption": {
    slug: "villainess-redemption",
    title: "恶女的救赎",
    author: "Haeun",
    artist: "星夜",
    genre: ["恋爱漫画", "都市剧情"],
    status: "连载中",
    description:
      "她曾是上流社会最令人畏惧的恶女，为达目的不择手段。然而当最亲近的人联合起来将她推入深渊后，她才意识到自己不过是一枚棋子。获得重来一次的机会，她决定不再做任何人的工具。这一次，她要夺回属于自己的一切，用真正的实力让所有背叛她的人付出代价。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20cover%20of%20a%20villainess%20with%20determined%20eyes%2C%20dark%20red%20dress%2C%20royal%20palace%20interior%2C%20dramatic%20shadows%2C%20clean%20composition%2C%20vertical%20poster%20style&width=400&height=560&seq=detail-cover-04&orientation=portrait",
    rating: 9.4,
    views: "1.2亿",
    followers: "87万",
    totalChapters: 132,
    lastUpdate: "2026-08-03",
    tags: ["恶女", "重生", "复仇", "商战", "女强"],
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: 132 - i,
      title: `第${132 - i}话`,
      date: `2026-${String(8 - Math.floor(i / 4)).padStart(2, "0")}-${String((i % 30) + 1).padStart(2, "0")}`,
      isFree: i > 2,
    })),
  },
  "omniscient-reader": {
    slug: "omniscient-reader",
    title: "全知读者视角",
    author: "Sing N Song",
    artist: "Sleepy-C",
    genre: ["奇幻冒险", "热血动作"],
    status: "连载中",
    description:
      "金独子是一个普通的上班族，他唯一的爱好就是阅读一部名为《在灭亡世界生存的三种方法》的网络小说。十年来，他是这部小说唯一的读者。当小说完结的那一天，小说中的世界竟然变成了现实。作为唯一的读者，他掌握着这个世界的所有秘密。他是否能利用这些知识在这个末日世界中存活下去？",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20of%20an%20office%20worker%20holding%20a%20glowing%20book%2C%20apocalyptic%20background%20with%20monsters%2C%20urban%20fantasy%20style%2C%20dramatic%20contrast%2C%20vertical%20poster&width=400&height=560&seq=detail-cover-05&orientation=portrait",
    rating: 9.7,
    views: "9800万",
    followers: "76万",
    totalChapters: 210,
    lastUpdate: "2026-08-03",
    tags: ["末世", "小说成真", "策略", "生存", "智慧型主角"],
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: 210 - i,
      title: `第${210 - i}话`,
      date: `2026-${String(8 - Math.floor(i / 4)).padStart(2, "0")}-${String((i % 30) + 1).padStart(2, "0")}`,
      isFree: i > 2,
    })),
  },
};